module.exports = __webpack_public_path__ + "static/support-c0a3085df1be5c8444c988ee658d7730.jpg";